import { render, staticRenderFns } from "./SmartGoalsTower.vue?vue&type=template&id=0a26a3bd&scoped=true&"
import script from "./SmartGoalsTower.vue?vue&type=script&lang=js&"
export * from "./SmartGoalsTower.vue?vue&type=script&lang=js&"
import style0 from "./SmartGoalsTower.vue?vue&type=style&index=0&id=0a26a3bd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a26a3bd",
  null
  
)

export default component.exports